import React from 'react';
import * as Yup from 'yup';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';

const haveFiles = (file) => {
  if (file === null) {
    return true;
  }
  return file;
};

export default Yup.object().shape({
  first_identity: Yup.string().required(
    <FormattedMessage
      id="onboarding_personal_form_required"
      defaultMessage={dlt['onboarding_personal_form_required']}
    />
  ),
  first_identity_number: Yup.string().required(
    <FormattedMessage
      id="onboarding_personal_form_required"
      defaultMessage={dlt['onboarding_personal_form_required']}
    />
  ),

  first_identity_image_front: Yup.mixed()
    .nullable()
    .test(
      'is file uploaded',
      <FormattedMessage
        id="onboarding_personal_form_required"
        defaultMessage={dlt['onboarding_personal_form_required']}
      />,
      haveFiles
    ),
  /*    .test(
      'is same',
      <FormattedMessage
        id="onboarding_identity_documents_form_upload_equal_error"
        defaultMessage={dlt['onboarding_identity_documents_form_upload_equal_error']}
      />,
      (value) => {
        if (value && value.name) {
          return false;
        }
      }
    ), */

  first_identity_image_back: Yup.mixed()
    .nullable()
    .test(
      'is file uploaded',
      <FormattedMessage
        id="onboarding_personal_form_required"
        defaultMessage={dlt['onboarding_personal_form_required']}
      />,
      haveFiles
    ),

  second_identity: Yup.string().required(
    <FormattedMessage
      id="onboarding_personal_form_required"
      defaultMessage={dlt['onboarding_personal_form_required']}
    />
  ),
  second_identity_number: Yup.string().required(
    <FormattedMessage
      id="onboarding_personal_form_required"
      defaultMessage={dlt['onboarding_personal_form_required']}
    />
  ),
  second_identity_image_front: Yup.mixed()
    .nullable()
    .test(
      'is file uploaded',
      <FormattedMessage
        id="onboarding_personal_form_required"
        defaultMessage={dlt['onboarding_personal_form_required']}
      />,
      haveFiles
    ),
  second_identity_image_back: Yup.mixed()
    .nullable()
    .test(
      'is file uploaded',
      <FormattedMessage
        id="onboarding_personal_form_required"
        defaultMessage={dlt['onboarding_personal_form_required']}
      />,
      haveFiles
    ),
});
